<template>
  <MPopover
    v-if="user"
    :ref="`popover-${guid}`"
    :destroy-tooltip-on-hide="false"
    trigger="click"
    placement="bottomRight"
    overlay-class-name="headerUserMenu"
    @show="handleShow"
    @hide="handleHide"
  >
    <a slot="trigger" href="javascript:;">
      <FlotoUserAvatar
        size="large"
        class="rounded-full cursor-pointer"
        :avatar="user.avatar"
      />
    </a>
    <MRow :gutter="0">
      <MCol class="w-64 items-center justify-around">
        <MRow>
          <MCol align="center" justify="middle">
            <FlotoUserAvatar
              :size="80"
              class="rounded-full cursor-pointer"
              :avatar="user.avatar"
            />
          </MCol>
        </MRow>
        <MRow class="mt-4">
          <MCol class="text-ellipsis">
            <div class="text-center">
              <h2 class="mb-0">{{ user.name }}</h2>
            </div>
            <div class="text-center text-ellipsis">
              <small>
                <span :title="user.email ? user.email : user.userLogOnName">
                  {{ user.email || user.userLogOnName }}
                </span>
              </small>
            </div>
          </MCol>
        </MRow>
        <MRow ref="editProfileRef" class="mt-4 justify-around" :gutter="0">
          <UserProfile
            v-if="!isCxoTechnician()"
            :tabindex="1"
            class="mb-1"
            @trigger="hide"
          />
          <MButton
            id="signout-btn"
            variant="error"
            class="mb-1"
            @click="performLogout"
          >
            {{ $t('logout') }}
          </MButton>
        </MRow>
        <MRow v-if="user.userType === 'technician' && !mspPortal" class="mt-4">
          <MCol class="text-center">
            <FlotoAnchorLink @click="handlePortalChange">
              <div class="font-semibold">
                {{ $t('view') }}
                {{
                  isInsidePortal ? technicianPortalTitle : customerPortalTitle
                }}
              </div>
            </FlotoAnchorLink>
          </MCol>
        </MRow>
        <MRow class="mt-4">
          <MCol
            v-if="!isPortalLogin && user.superAdminRole"
            class="text-center"
          >
            <FlotoLink :to="$modules.getModuleRoute('product-setup')">
              <div class="font-semibold" @click="hide">
                {{ $tc('product_guide') }}
              </div>
            </FlotoLink>
          </MCol>
        </MRow>
      </MCol>
    </MRow>
  </MPopover>
</template>

<script>
import Bus from '@utils/emitter'
import { isCxoTechnician } from '@utils/auth'
import { authMethods, authComputed } from '@state/modules/auth/'
import { MspConfigComputed } from '@state/modules/msp-config/helpers'
import { LicenseComputed } from '@state/modules/license'
import UserProfile from './user-profile'
import { generateId } from '@utils/id'

export default {
  name: 'UserDropdown',
  components: { UserProfile },
  inject: {
    popupContext: {
      default: () => ({
        popupManagerData: () => [],
      }),
    },
  },
  props: {
    portalMode: { type: Boolean, default: false },
    customerPortalTitle: { type: String, default: 'support_portal' },
    technicianPortalTitle: { type: String, default: 'technician_portal' },
  },
  data() {
    this.guid = generateId()
    this.isCxoTechnician = isCxoTechnician
    return {}
  },
  computed: {
    ...authComputed,
    ...MspConfigComputed,
    ...LicenseComputed,
    isInsidePortal() {
      return this.isPortalLogin
      // return this.$route.path.indexOf('support-portal') >= 0
    },
  },
  methods: {
    ...authMethods,
    handleHide() {
      if (this.$refs[`popover-${this.guid}`]) {
        this.$refs[`popover-${this.guid}`].hide()
      }
      const popovefRef = `popover-${this.guid}`
      if (this.popupContext && this.popupContext.popupManagerData.length) {
        const index = this.popupContext.popupManagerData.findIndex(
          (item) => Object.keys(item)[0] === popovefRef
        )

        if (index !== -1) {
          // Use splice to remove the element at the found index
          this.popupContext.popupManagerData.splice(index, 1)
        }
      }
    },

    handleShow() {
      setTimeout(() => {
        const keyExists = () => {
          const popupManagerData = this.popupContext.popupManagerData || []
          return popupManagerData.some((item) =>
            item.hasOwnProperty(`popover-${this.guid}`)
          )
        }

        if (
          this.popupContext &&
          this.popupContext.popupManagerData &&
          !keyExists()
        ) {
          const dynamicKey = `popover-${this.guid}`

          const callableObject = function () {
            this.handleHide()
          }.bind(this)

          callableObject.refData = this.$refs.editProfileRef.$el

          this.popupContext.popupManagerData.push({
            [dynamicKey]: callableObject,
          })
        }
      }, 200)
    },
    hide() {
      this.handleHide()
    },
    performLogout() {
      const currentUser = this.user
      this.logout()
      Bus.$emit('auth:logout', currentUser)
      if (this.$route.name !== 'support-portal') {
        this.$modules.replace('support-portal')
      }
    },
    handlePortalChange() {
      this.$router.push(
        this.$modules.getModuleRoute(
          this.isInsidePortal ? 'dashboard' : 'support-portal'
        )
      )
    },
  },
}
</script>

<style lang="less">
.headerUserMenu {
  .@{ant-prefix}-popover-content {
    margin-top: 14px;
  }
  .@{ant-prefix}-popover-arrow {
    top: 20px !important;
  }
  .@{ant-prefix}-popover-arrow,
  .@{ant-prefix}-tooltip-arrow {
    display: none;
  }
  & .@{ant-prefix}-popover-inner {
    @apply border-solid border-primary border-l-0 border-r-0 border-t-0 rounded-lg;

    background-color: var(--user-dropdown-button-bg);
    border-bottom-width: 5px;
  }
}
</style>
